export { default } from './SvgIcon/SvgIcon';
export type { IconProps } from './SvgIcon/SvgIcon';

import SvgIcon, { type IconProps } from './SvgIcon/SvgIcon';

const makeIcon = (path: string, viewBox = '0 -960 960 960', w = 24, h = 24) => {
  const Icon = (props: IconProps) => (
    <SvgIcon width={w} height={h} viewBox={viewBox} {...props}>
      <path d={path} />
    </SvgIcon>
  );
  return Icon;
};

export const CancelIcon = makeIcon(
  'M480-424 284-228q-11 11-28 11t-28-11q-11-11-11-28t11-28l196-196-196-196q-11-11-11-28t11-28q11-11 28-11t28 11l196 196 196-196q11-11 28-11t28 11q11 11 11 28t-11 28L536-480l196 196q11 11 11 28t-11 28q-11 11-28 11t-28-11L480-424Z',
);

export const LightbulbIcon = makeIcon(
  'M480-80q-33 0-56.5-23.5T400-160h160q0 33-23.5 56.5T480-80ZM320-200v-80h320v80H320Zm10-120q-69-41-109.5-110T180-580q0-125 87.5-212.5T480-880q125 0 212.5 87.5T780-580q0 80-40.5 149T630-320H330Z',
);

export const CloseIcon = makeIcon(
  'M480-424 284-228q-11 11-28 11t-28-11q-11-11-11-28t11-28l196-196-196-196q-11-11-11-28t11-28q11-11 28-11t28 11l196 196 196-196q11-11 28-11t28 11q11 11 11 28t-11 28L536-480l196 196q11 11 11 28t-11 28q-11 11-28 11t-28-11L480-424Z',
);

export const MapIcon = makeIcon(
  'M480-480q33 0 56.5-23.5T560-560q0-33-23.5-56.5T480-640q-33 0-56.5 23.5T400-560q0 33 23.5 56.5T480-480Zm0 294q122-112 181-203.5T720-560q0-109-69.5-184.5T480-820q-101 0-170.5 75.5T240-560q0 71 59 162.5T480-186Zm0 106Q319-217 239.5-334.5T160-560q0-150 96.5-245T480-900q127 0 223.5 95T800-560q0 112-79.5 229.5T480-80Zm0-480Z',
);

export const AddIcon = makeIcon('M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z');

export const RemoveIcon = makeIcon('M200-440v-80h560v80H200Z');

export const CheckIcon = makeIcon(
  'm382-354 339-339q12-12 28-12t28 12q12 12 12 28.5T777-636L410-268q-12 12-28 12t-28-12L182-440q-12-12-11.5-28.5T183-497q12-12 28.5-12t28.5 12l142 143Z',
);

export const OpenInNewIcon = makeIcon(
  'M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h280v80H200v560h560v-280h80v280q0 33-23.5 56.5T760-120H200Zm188-212-56-56 372-372H560v-80h280v280h-80v-144L388-332Z',
);

export const MenuIcon = makeIcon(
  'M120-240v-80h720v80H120Zm0-200v-80h720v80H120Zm0-200v-80h720v80H120Z',
);
